export const fields = `
  title
`

export const fragment = (name = 'pageData') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
